module.exports = __webpack_public_path__ + "static/media/02.750da8c3.png";